import { getRedoReturnCarrierPickerGroup } from "../shipping/redo-return-carrier-registry";

/**
 * Customer-facing name for a return label's carrier.
 *
 * Carrier codes name the *service* a label was bought on, which is not where a
 * customer drops the package off: injection services like FedExSmartPost and
 * UPSSurePost go to FedEx and UPS, and a Sendle US label is handed to USPS.
 */
export const getCarrierDisplayName = (
  carrier_name: string,
  country_code: string,
) => {
  switch (carrier_name) {
    case "UspsShip": {
      carrier_name = "USPS";

      break;
    }
    case "USPSReturns": {
      carrier_name = "USPS";

      break;
    }
    case "Sendle": {
      if (country_code === "US") {
        carrier_name = "USPS";
      }

      break;
    }
    case "FedExSmartPost": {
      carrier_name = "FedEx";

      break;
    }
    case "UPSSurePost": {
      carrier_name = "UPS";

      break;
    }
    case "UPSMailInnovations": {
      carrier_name = "UPS";

      break;
    }
    case "CanadaPost": {
      carrier_name = "Canada Post";

      break;
    }
    case "NZPost": {
      carrier_name = "NZ Post";

      break;
    }
    default: {
      carrier_name =
        getRedoReturnCarrierPickerGroup(carrier_name) ?? carrier_name;
    }
  }
  return carrier_name;
};
